import type { Achievement } from "../achievement.types";
import { freeMoves, goldInterior } from "../moveHistory";

export const offTheMapAchievement: Achievement = {
  id: "offTheMap",
  name: "Off the Map",
  icon: "map-outline",
  description: "Won without touching the gold path until the final step.",
  isProgressive: true,
  // Every move before the winning click, backtracked ones included, must stay
  // off the gold path: no gold step and no landing on a gold word.
  // Rule unchanged from v1's Dancing to a Different Beat (spec 2026-10-20 §3.2).
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport) return false;
    const before = freeMoves(gameReport, gameStatus);
    if (before.length === 0) return false;
    const gold = goldInterior(gameReport);
    return before.every((m) => !m.isGlobalOptimal && !gold.has(m.playerChose));
  },
};
